export default "__VITE_ASSET__CgEZ7B$Y__"